<template>
  <b-overlay
    rounded="sm"
    :show="!data"
  >
    <b-card
      body-class="pb-50"
      style="min-height:260px"
    >
      <h6>Orders</h6>
      <h2
        v-if="data && data.series"
        class="font-weight-bolder mb-1"
      >
        {{ data.total }}
      </h2>
      <!-- chart -->
      <vue-apex-charts
        v-if="data && data.series"
        height="150"
        :options="statisticsOrder.chartOptions"
        :series="[data.series]"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $barColor = '#f3f3f3'

export default {
  components: {
    BCard,
    BOverlay,
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      statisticsProfit: {
        series: [
          {
            data: [20, 0, 20, 5, 30, 15, 45],
          },
        ],
      },
      statisticsOrder: {
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
              top: -15,
              bottom: -15,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '20%',
              startingShape: 'rounded',
              colors: {
                backgroundBarColors: [$barColor, $barColor, $barColor, $barColor, $barColor],
                backgroundBarRadius: 5,
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.warning],

          xaxis: {
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },
    }
  },
}
</script>
